var _path, _g, _path2, _g2, _path3, _g3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2222_424887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 16,
    width: 34,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.322 45.3308L40.6972 45.3353C49.4272 45.5457 56.4681 53.079 56.6647 62.4167L56.669 62.818H23.9751C23.9751 53.1616 31.2928 45.3308 40.322 45.3308ZM39.902 16.1851C45.3576 16.1851 49.7987 21.2157 49.9584 27.4936L49.9629 27.8436L49.9584 28.1936C49.8016 34.356 45.5177 39.3175 40.1985 39.4959L39.902 39.5009L39.6 39.4957C34.2826 39.314 30.0016 34.3505 29.8477 28.1872L29.8434 27.8436L29.8478 27.4936C30.0075 21.2157 34.4474 16.1851 39.902 16.1851Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2222_424887)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7837 67.6757H60.8605V11.3262H19.7837V67.6757Z",
    fill: "#E7E7E7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2222_424887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 24,
    width: 28,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7112 48.9266L60.0238 48.9304C67.298 49.1093 73.1647 55.5157 73.3285 63.4567L73.332 63.7979H46.0903C46.0903 55.586 52.1877 48.9266 59.7112 48.9266ZM59.3612 24.1406C63.907 24.1406 67.6075 28.4188 67.7405 33.7576L67.7443 34.0552L67.7405 34.3528C67.6099 39.5935 64.0404 43.8128 59.6083 43.9645L59.3612 43.9687L59.1096 43.9643C54.6789 43.8098 51.1118 39.5888 50.9836 34.3475L50.98 34.0552L50.9837 33.7576C51.1167 28.4188 54.8163 24.1406 59.3612 24.1406Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2222_424887)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5977 67.9287H76.8243V20.0083H42.5977V67.9287Z",
    fill: "#E7E7E7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2222_424887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 24,
    width: 28,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2873 48.9266L20.5999 48.9304C27.8741 49.1093 33.7409 55.5157 33.9047 63.4567L33.9082 63.7979H6.6665C6.6665 55.586 12.7639 48.9266 20.2873 48.9266ZM19.9373 24.1406C24.4832 24.1406 28.1837 28.4188 28.3167 33.7576L28.3204 34.0552L28.3167 34.3528C28.1861 39.5935 24.6166 43.8128 20.1844 43.9645L19.9373 43.9687L19.6857 43.9643C15.2551 43.8098 11.688 39.5888 11.5597 34.3475L11.5562 34.0552L11.5599 33.7576C11.6929 28.4188 15.3924 24.1406 19.9373 24.1406Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2222_424887)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17383 67.9287H37.4005V20.0083H3.17383V67.9287Z",
    fill: "#E7E7E7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.3085,
    height: 5.66893,
    transform: "translate(30.7061 58.1382)",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.054192f8be6f7e39b78b1b06ec1da371.svg";
export { ForwardRef as ReactComponent };